module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB3001-c69433a2e30ff9b2ca5001d2025779fa.png";